import { render, staticRenderFns } from "./UserAddress.vue?vue&type=template&id=d7e2c528&scoped=true"
import script from "./UserAddress.vue?vue&type=script&lang=js"
export * from "./UserAddress.vue?vue&type=script&lang=js"
import style0 from "./UserAddress.vue?vue&type=style&index=0&id=d7e2c528&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7e2c528",
  null
  
)

export default component.exports